// extracted by mini-css-extract-plugin
export default {"user-avatar":"_3Ho5z","userAvatar":"_3Ho5z","pixelated":"_1VDZg"};